import { Check, X } from "lucide-react";
import { COMPARISON } from "@/data/content";
import { Reveal, SectionHeading } from "@/components/common/ui";

export const Comparison = () => (
  <section className="bg-[#FFFCFA] py-24 md:py-32" data-testid="comparison-section">
    <div className="mx-auto max-w-[1000px] px-6 md:px-12">
      <SectionHeading align="center" overline="Designed for Better Results"
        title="Us Vs Them"
        sub="See how the Leopard Luxe™ compares to the basic masks flooding the market." className="mb-14" />

      <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] md:block md:space-y-4 md:overflow-visible md:pb-0 [&::-webkit-scrollbar]:hidden">
        {COMPARISON.map((row, i) => (
          <Reveal key={row.feature} delay={i * 0.05}
            className="w-[80%] shrink-0 snap-start grid items-center gap-4 rounded-[1.75rem] border border-[#F2E8E6] bg-white p-5 sm:w-[62%] md:w-full md:grid-cols-[1.1fr_1fr_1fr] md:gap-6 md:p-6">
            <p className="font-display text-xl text-[#2C2B2C] md:text-2xl">{row.feature}</p>

            <div className="flex items-center gap-3 rounded-2xl bg-[#FBC4A8]/30 px-4 py-3">
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-[#FBC4A8] text-[#232222]"><Check className="h-4 w-4" strokeWidth={2.5} /></span>
              <div>
                <p className="text-[0.6rem] font-semibold uppercase tracking-[0.18em] text-[#232222]">Aura Glow</p>
                <p className="text-base font-medium text-[#2C2B2C]">{row.aura}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 rounded-2xl bg-[#FFFCFA] px-4 py-3">
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-[#E4DACA] text-[#8A7F86]"><X className="h-4 w-4" strokeWidth={2.5} /></span>
              <div>
                <p className="text-[0.6rem] font-semibold uppercase tracking-[0.18em] text-[#8A7F86]">Other Masks</p>
                <p className="text-base text-[#8A7F86]">{row.others}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
